import { getSiteSupportedLanguages, getTldLanguageInfo, getDataCenterIdFromCurrentUrl, getDataCenterById, getSubdomainFromLanguageCodeAndDataCenter, getDefaultSubdomainForDataCenter } from '@sm/locale';
var getFooterLanguageList = function getFooterLanguageList(url, tld) {
  var languages = getSiteSupportedLanguages();
  var languageInfo = getTldLanguageInfo(tld);
  if (!url) {
    return [];
  }
  return languages.map(function (language) {
    var dataCenterId = getDataCenterIdFromCurrentUrl(url);
    var dataCenter = getDataCenterById(dataCenterId);
    var subdomain = getSubdomainFromLanguageCodeAndDataCenter(language.code, dataCenterId);
    var langTld = 'com';
    var primaryCCTldExistsForLanguage = language.tld !== 'com';
    var notOnCCTldCurrently = ['com', 'net'].includes(tld);
    var languageSupportedByCurrentCCTld = languageInfo === null || languageInfo === void 0 ? void 0 : languageInfo.supportedLanguages.includes(language.code);
    if (primaryCCTldExistsForLanguage && dataCenter.CCTldSupport && (notOnCCTldCurrently || !languageSupportedByCurrentCCTld)) {
      var _language$tld;
      subdomain = getDefaultSubdomainForDataCenter(dataCenterId);
      langTld = (_language$tld = language.tld) !== null && _language$tld !== void 0 ? _language$tld : '';
    } else if (languageSupportedByCurrentCCTld && dataCenter.CCTldSupport) {
      langTld = tld;
    }
    return {
      name: language.name,
      subdomain: subdomain,
      tld: langTld,
      displayName: language.displayName,
      sortOrder: language.displayOrder
    };
  });
};
export default getFooterLanguageList;
//# sourceMappingURL=getFooterLanguageList.js.map